
export enum UniquePermissionsResult {
  No = 0,
  Yes = 1,
  NoAccess = 2,
  Error = 3,
}